import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IncrediSelect } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { inject, ref, watch } from 'vue';
import { IKWorkloadsPageData } from '@/views/workloads/workloads.injectionKeys';
import { useMatomo } from '@/services/matomo/matomo.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'buildGroupFilter',
  setup(__props) {

const matomo = useMatomo();
const workloadsPageData = inject(IKWorkloadsPageData);
const modelValue = ref(workloadsPageData?.filter?.get?.value?.buildGroup as string[]);

const handleSubmitFilter = () => {
  workloadsPageData?.filter?.setBuildGroup(modelValue.value);
  matomo?.trackEvent({
    category: 'Workloads Filter',
    action: 'Apply build Group',
  });
};

const handleUpdateFilter = (selection: []) => {
  modelValue.value = selection;
  if (modelValue.value.length === 0) {
    handleSubmitFilter();
  }
};

watch(
  () => workloadsPageData?.filter?.get?.value?.buildGroup,
  (newValue: any) => {
    modelValue.value = newValue;
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediSelect), {
        items: _unref(workloadsPageData)?.workloadsBuildGroups.value as any,
        "model-value": (modelValue.value) as any,
        size: "tiny",
        design: "ghost",
        direction: "bottom-sticky-left",
        label: "Build Group",
        multiple: "",
        clearable: "",
        "list-max-width": 216,
        "list-max-height": 460,
        "is-searchable": "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (item) => handleUpdateFilter(item)),
        onSubmit: handleSubmitFilter
      }, null, 8, ["items", "model-value"])
    ]),
    _: 1
  }))
}
}

})